module.exports = __webpack_public_path__ + "img/exam_jan_2025_gw1hli6d.dc173f92.jpg";